// @flow
import React from 'react';

export const EnumField = ({ userValue, definition }: { userValue: Object, definition: Object }) => (
  <div>{definition.values[userValue.value]}</div>
);
